var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRPhoneOut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsserif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "btn-secondary",
    serifid: "btn secondary"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "ph-desktop"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "ph-note-pencil"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "ph-pen-nib"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-5",
    serifid: "Rating 5"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4-5",
    serifid: "Rating 4,5"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-4",
    serifid: "Rating 4"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3-5",
    serifid: "Rating 3,5"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-3",
    serifid: "Rating 3"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2-5",
    serifid: "Rating 2,5"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-2",
    serifid: "Rating 2"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1-5",
    serifid: "Rating 1,5"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Rating-1",
    serifid: "Rating 1"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass1",
    serifid: "magnifying-glass"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "file"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "file-earmark"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "file1",
    serifid: "file"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "boxes-stacked"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "chat-left-text"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "iconR-phone-out",
    x: 0,
    y: 0,
    width: 23.998,
    height: 23.998,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.127,3.606c-0.003,0.004 -1.144,1.146 -1.144,1.146c-0.857,0.856 -1.231,2.139 -0.811,3.331c-0,0 -0,0 -0,0c1.035,2.942 2.719,5.613 4.928,7.815c2.202,2.209 4.874,3.893 7.816,4.928c1.193,0.42 2.474,0.046 3.331,-0.81c0,-0 1.145,-1.145 1.145,-1.145c0.882,-0.88 0.791,-2.335 -0.193,-3.101l-2.554,-1.987c-0.502,-0.391 -1.157,-0.529 -1.774,-0.374l-2.425,0.605c-0.208,0.053 -0.428,-0.008 -0.58,-0.16c-0,-0 -2.721,-2.721 -2.721,-2.721c-0.151,-0.151 -0.212,-0.372 -0.161,-0.579c0,-0 0.606,-2.426 0.606,-2.426c0.155,-0.617 0.017,-1.272 -0.374,-1.774l-1.987,-2.554c-0.392,-0.505 -0.997,-0.801 -1.636,-0.801c-0.55,0 -1.077,0.219 -1.466,0.607Zm1.949,1.09l1.987,2.555c0.114,0.148 0.155,0.341 0.11,0.523l-0.607,2.425c-0.176,0.706 0.031,1.454 0.546,1.968l2.72,2.721c0.514,0.514 1.262,0.721 1.968,0.545l2.425,-0.606c0.182,-0.045 0.375,-0.005 0.523,0.11l2.555,1.987c0.149,0.116 0.236,0.294 0.236,0.482c-0,0.163 -0.065,0.318 -0.179,0.433l-1.146,1.145c-0.496,0.495 -1.198,0.682 -1.815,0.465c-2.735,-0.963 -5.218,-2.529 -7.265,-4.583c-0,0 -0,0 -0,0c-2.054,-2.047 -3.62,-4.53 -4.583,-7.265c-0.217,-0.617 -0.03,-1.319 0.465,-1.815l1.145,-1.147c0.115,-0.114 0.27,-0.179 0.433,-0.179c0.188,0 0.366,0.087 0.482,0.236Zm8.106,-1.003c0,0.381 0.313,0.694 0.694,0.694l2.755,-0l-4.354,4.353c-0.13,0.13 -0.203,0.307 -0.203,0.491c-0,0.381 0.313,0.694 0.694,0.694c0.184,-0 0.361,-0.073 0.491,-0.203l4.353,-4.354l-0,2.755c-0,0.381 0.313,0.694 0.694,0.694c0.38,-0 0.693,-0.313 0.693,-0.694c0,0 0,-4.43 0,-4.43c0,-0.38 -0.313,-0.693 -0.693,-0.693c-0,-0 -4.43,-0 -4.43,-0c-0.381,-0 -0.694,0.313 -0.694,0.693Z",
    style: {
      fillRule: "nonzero"
    }
  }), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass2",
    serifid: "magnifying-glass"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "pin-map"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRPhoneOut);
export default __webpack_public_path__ + "static/media/iconR-phone-out.443526d89e8e5aa56a81ce579a24c731.svg";
export { ForwardRef as ReactComponent };